import "@fontsource/roboto";
import { deDE } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
	interface Theme {
		sidebar: {
			width: string;
		};
		spacing: (factor: number) => string;
		graphPalette: string[];
	}

	interface ThemeOptions {
		sidebar?: {
			width?: string;
		};
		graphPalette?: string[];
	}
}
// Dev first colors
// const primaryColor = "#6498E2";
// const secondaryColor = "#303133";

// Neue GNAG Farben
const primaryColor = "#1a455c";
// const headerColor = "#27637C";
const secondaryColor = "#abd070";

const colorPalette = [
	"#213555",
	"#FFC900",
	"#005461",
	"#76153C",
	"#DDC57A",
	"#E83C91",
	"#90AB8B",
	"#1581BF",
	"#FFFCC5",
	"#9CC6DB",
	"#ED985F",
	"#8F0177",
	"#547792",
	"#F39F9F",
	"#FFECC0",
	"#0A0323",
];

const themeOptions = {
	palette: {
		primary: {
			main: primaryColor,
		},
		secondary: {
			main: secondaryColor,
		},
	},

	sidebar: {
		width: "320px",
	},

	graphPalette: colorPalette,
};

const ledgerTheme = createTheme(themeOptions);
const ledgerThemeDe = createTheme(themeOptions, deDE);

export { ledgerThemeDe };
export default ledgerTheme;
